export var SharingContentMutationTypes;
(function (SharingContentMutationTypes) {
    SharingContentMutationTypes["INIT_STATE"] = "INIT_STATE";
    SharingContentMutationTypes["FETCH_SHARING_CONTENTS"] = "FETCH_SHARING_CONTENTS";
    SharingContentMutationTypes["REPLACE_SHARING_CONTENT"] = "REPLACE_SHARING_CONTENT";
    SharingContentMutationTypes["CHANGE_SORT"] = "CHANGE_SORT";
    SharingContentMutationTypes["REMOVE_SHARING_CONTENT"] = "REMOVE_SHARING_CONTENT";
})(SharingContentMutationTypes || (SharingContentMutationTypes = {}));
